<template>
	<footer :class="{ footer: true, absolute: absolute }">
		<p class="copyright">© {{ theYear }} {{ siteName }} <span v-if="theVersion" v-html="theVersion" /></p>

		<div class="socials">
			<a href="https://www.instagram.com/partnerup_hub/" target="_blank"><Icon type="instagram" colour="#ffffff" class="icon" /></a>
			<a href="https://www.linkedin.com/company/partner-up-hub/" target="_blank"><Icon type="linkedin" colour="#ffffff" class="icon" /></a>
		</div>

		<div class="policy" v-if="!isPublic">
			<a href="https://partneruphub.com/terms-conditions/" target="_blank">Terms & Conditions</a>
			<a href="https://partneruphub.com/privacy-policy/" target="_blank">Privacy Policy</a>
			<a href="https://partneruphub.com/faqs/" target="_blank">FAQs</a>
		</div>
	</footer>
</template>

<script>
import { computed, getCurrentInstance } from "vue";
import general from "./../utils/general";
import Icon from "./Display/BaseIcon.vue";
export default {
	name: "AppFooter",
	components: {
		Icon,
	},
	props: {
		siteName: {
			type: String,
			default: "",
		},
		absolute: {
			type: Boolean,
			default: false,
		},
	},
	setup() {
		const vm = getCurrentInstance().proxy;

		const resolvedRouteMeta = computed(() => {
			const matched = vm.$route.matched || [];
			if (matched.length) {
				const last = matched[matched.length - 1];
				return (last && last.meta) || {};
			}
			return vm.$route.meta || {};
		});

		const isPublic = computed(() => {
			return resolvedRouteMeta.value.public;
		});

		const theYear = computed(() => {
			return new Date().getFullYear();
		});

		const theVersion = computed(() => {
			if (typeof lastUpdate !== "undefined" && general.isAdmin()) {
				//return "<br>The version you are seeing is from the " + general.dateFormat("jS F 'y @ H:i", lastUpdate.replace("_", " "));
			}
			if (typeof version !== "undefined") {
				return "<br>ver: " + general.dateFormat("dm", lastUpdate.replace("_", " ")) + "." + version.substring(0, 7);
			}
			return undefined;
		});

		return {
			isPublic,
			theYear,
			theVersion,
		};
	},
};
</script>

<style lang="less" scoped>
@import "./../assets/css/less/_helper.less";
@import "./../assets/css/less/_settings.less";
.footer {
	position: relative;
	height: 108px;
	background-color: fade(@guidedRose, 70%);
	background-color: fade(@formDefaultColour, 70%);
	box-sizing: content-box;
	padding-bottom: 30px;

	&.fade {
		opacity: 0.35;
	}

	.policy {
		width: 285px;
		text-align: center;
		padding: 20px 0 0;

		a {
			color: #fff;
			font-size: 12px;
			margin: 0 10px;
			display: inline-block;
		}
	}

	.socials {
		left: 0;
		top: 0;
		display: flex;
		padding: 10px 0 0 20px;

		a {
			width: 25px;
			height: 25px;
			display: block;
			margin: 0 10px 0 0;

			&.twitter {
				margin-top: 2px;
			}

			.icon {
				vertical-align: top;
			}
		}
	}

	.copyright {
		margin: 0;
		padding: 0;
		text-align: center;
		font-size: 12px;
		color: #fff;
		width: 120px;
		position: absolute;
		left: 50%;
		bottom: 10px;
		margin-left: -60px;
		span {
			color: inherit;
			font-size: 0.8em;
		}
	}

	&.absolute {
		position: absolute;
		bottom: 0;
		padding-bottom: 0px;
		width: 100%;
		left: 0;

		.copyright {
			padding: 0;
		}
	}
}
@media screen and (min-width: 560px) {
	.footer {
		display: flex;
		height: 64px;
		.policy {
			padding: 0;
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			top: 12px;
		}
		.socials {
			position: absolute;
		}
	}
}

@media screen and (min-width: 1024px) {
	.footer {
		height: 48px;
		padding: 0;
		.policy {
			right: 80px;
			transform: none;
			left: auto;
			top: 12px;
		}
		.socials {
			padding-top: 12px;
		}
		.copyright {
			bottom: 5px;
		}
	}
}

@media screen and (min-width: 1024px) and (max-height: 380px) {
	.footer {
		display: none;
	}
}
</style>